import * as actionTypes from "./actionTypes"

export function addArticle(article: IArticle) {
  console.log(article)
  const action: ArticleAction = {
    type: actionTypes.ADD_ARTICLE,
    article,
  }

  return simulateHttpRequest(action)
}

export function simulateHttpRequest(action: ArticleAction) {
  return (dispatch: DispatchType) => {
    // console.log("sdf")
    // console.log(action)
    setTimeout(() => {
      dispatch(action)
    }, 500)
  }
}